import { useState, useEffect } from "react";
import api from "../../utils/api";

export default function EditUser({ user, onSuccess }) {
  const [newEmail, setNewEmail] = useState("");
  const [newRole, setNewRole] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get("/products", { withCredentials: true });
        setAllProducts(res.data.products);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    if (user) {
      setNewEmail(user.email);
      setNewRole(user.role);
      setNewStatus(user.status);
      setSelectedProducts(user.product_list || []);
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newEmail || !newRole || !newStatus) {
      alert("Please insert all information.");
      return;
    }

    try {
      await api.patch(
        `/users/${user._id}`,
        {
          newEmail,
          newRole,
          newStatus,
          product_list: selectedProducts,
        },
        { withCredentials: true },
      );

      alert("User updated successfully!");
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const handleProductToggle = (productName) => {
    setSelectedProducts((prev) =>
      prev.includes(productName)
        ? prev.filter((p) => p !== productName)
        : [...prev, productName],
    );
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Update User</h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Email
        </label>
        <input
          type="text"
          placeholder="Email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Role
        </label>
        <select
          value={newRole}
          onChange={(e) => setNewRole(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-white
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="" disabled>
            Select Role
          </option>
          <option value="Admin">Admin</option>
          <option value="Manager">Manager</option>
          <option value="User">User</option>
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Status
        </label>
        <select
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800 bg-white
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="" disabled>
            Select Status
          </option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-2">
          Products
        </label>
        <div className="flex flex-wrap gap-3 max-h-64 overflow-y-auto border rounded-lg p-3">
          {loading ? (
            <p>Loading</p>
          ) : allProducts.length ? (
            allProducts.map((product) => (
              <label
                key={product._id}
                className="flex items-center gap-2 cursor-pointer p-2 rounded hover:bg-gray-100 transition"
              >
                <input
                  type="checkbox"
                  value={product.name}
                  checked={selectedProducts.includes(product.name)}
                  onChange={() => handleProductToggle(product.name)}
                  className="h-4 w-4"
                />
                {product.imageUrl && (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${product.imageUrl}`}
                    alt={product.name}
                    className="w-6 h-6 object-cover rounded"
                  />
                )}
                <span className="text-gray-700">{product.name}</span>
              </label>
            ))
          ) : (
            <span className="text-gray-500">No products available.</span>
          )}
        </div>
      </div>

      <button
        type="submit"
        className="w-full rounded-lg bg-blue-600 py-2.5 text-white font-medium
               hover:bg-blue-700 transition focus:outline-none focus:ring-2
               focus:ring-blue-500 focus:ring-offset-2"
      >
        Update User
      </button>
    </form>
  );
}
